// removed by extract-text-webpack-plugin
module.exports = {"cardNfo":"cardInfo_cardNfo_3Vp3H","teamName":"cardInfo_teamName_kqbGg","date":"cardInfo_date_1Vf07"};


//////////////////
// WEBPACK FOOTER
// ./src/components/widgets/CardInfo/cardInfo.css
// module id = 336
// module chunks = 0